module.exports = __webpack_public_path__ + "img/gld_gbt831_1988.prt.b7c370e7.jpg";